module.exports = __webpack_public_path__ + "img/Miguel-Pujadas.3e058504.jpg";